module.exports = __webpack_public_path__ + "static/media/ic-cart-open-white.68d66736.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-cart-open-white.svg
// module id = 606
// module chunks = 14